import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";

import Header from "@/components/Header";
import Hero from "@/components/Hero";
import PainSection from "@/components/PainSection";
import OutcomeSection from "@/components/OutcomeSection";
import ProductSection from "@/components/ProductSection";
import AboutMeSection from "@/components/AboutMeSection";
import ServicesSection from "@/components/ServicesSection";
import FinalCTA from "@/components/FinalCTA";
import BookingSection from "@/components/BookingSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";
import ProtectedRoute from "@/components/ProtectedRoute";

import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import AGBPage from "@/pages/AGBPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import useSeo from "@/hooks/useSeo";

function Landing() {
  useSeo({
    description:
      "Personal Training und Mikronährstoffberatung aus einer Hand – im Chiemgau. Ganzheitlich statt Flickenteppich aus mehreren Experten.",
    path: "/",
  });
  return (
    <main data-testid="landing-page" className="min-h-screen bg-[#F7F9FB]">
      <Header />
      <Hero />
      <PainSection />
      <AboutMeSection />
      <OutcomeSection />
      <ProductSection />
      <ServicesSection />
      <FinalCTA />
      <BookingSection />
      <ContactForm />
      <Footer />
    </main>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AGBPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeadsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
